import { Routes } from '@angular/router';
import { SigninComponent } from './pages/signin/signin.component';
import { SignoutComponent } from './pages/signout/signout.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { WebformComponent } from './pages/webform/webform.component';

import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { GDPRComponent } from './pages/gdpr/gdpr.component';

export const routes: Routes = [

  { path: "signin", component: SigninComponent },
  { path: "signout", component: SignoutComponent },
  { path: "unauthorized", component: UnauthorizedComponent },
  { path: "webform", component: WebformComponent }, //TODO: (2024-08-28) Ta bort denna när det inte längre finns länkar med "/webform" hit...

  { path: "GDPR/:token", component: GDPRComponent},
  
  { path: "", loadComponent: () => import('./pages/overview/overview.component').then(m => m.OverviewComponent), canActivate: [AutoLoginPartialRoutesGuard] },
  
  { path: "elearning", loadComponent: () => import('./pages/elearning/elearning.component').then(m => m.ElearningComponent), canActivate: [AutoLoginPartialRoutesGuard] },
  { path: "elearning/:videoId", loadComponent: () => import('./pages/elearning/elearning.component').then(m => m.ElearningComponent), canActivate: [AutoLoginPartialRoutesGuard] },
  
  { path: "admin", loadChildren: () => import("./modules/admin/admin.module").then(m => m.AdminModule), canActivate: [AutoLoginPartialRoutesGuard] },
  
];

